import React from "react";
import { getXPProgress } from "./leveling";

export default function XPBar({ xp }) {
  const { level, xpInLevel, xpToNextLevel, progress } = getXPProgress(xp);

  return (
    <div className="xpbar-container">
      <div className="xpbar-bar">
        <div className="xpbar-fill" style={{ width: `${progress * 100}%` }} />
      </div>
      <div className="xpbar-text">
        <p style={{ margin: "0" }}>Lvl. {level} </p>
        <p style={{ fontSize: "10px", fontWeight: "500", whiteSpace: "nowrap", margin: "0", color: "rgba(255, 255, 255, 0.6)" }}>
          {xpInLevel} / {xpToNextLevel} XP
        </p>
      </div>
    </div>
  );
}
